module.exports = __webpack_public_path__ + "img/uk-hotels-3.46ecd7b1.png";